module.exports = __webpack_public_path__ + "static/img/22.d968cd9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/news/hangye/20200520/22.png
// module id = kM91
// module chunks = 1